/**
 * Types for Raven embed PostMessage communication
 * Must match Raven's embed messaging constants (Epic 02)
 */

// Message types - MUST match Raven's RAVEN_MESSAGES
export const RAVEN_MESSAGES = {
  // Incoming from Raven (Raven -> React)
  READY: "RAVEN_READY",
  ROUTE_CHANGE: "RAVEN_ROUTE_CHANGE",
  ERROR: "RAVEN_ERROR",
  NAVIGATE_PARENT: "RAVEN_NAVIGATE_PARENT",

  // Outgoing to Raven (React -> Raven)
  NAVIGATE: "RAVEN_NAVIGATE",
} as const;

export interface RavenEmbedRef {
  /** Navigate to a path within Raven */
  navigate: (path: string) => void;
  /** Check if Raven is ready */
  readonly isReady: boolean;
}

export interface RavenEmbedProps {
  /** Initial path within Raven (e.g., '/channel/general') */
  initialPath?: string;
  /** Additional className for container */
  className?: string;
  /** Called when Raven is ready */
  onReady?: () => void;
  /** Called when route changes within Raven */
  onRouteChange?: (path: string, title: string) => void;
  /** Called on error */
  onError?: (error: string) => void;
  /** Called when Raven requests parent navigation (e.g., back button) */
  onNavigateParent?: (action: string) => void;
}

export interface RavenMessage {
  type: string;
  payload?: unknown;
  source?: string;
  timestamp?: number;
}

// Payload types
export interface RavenReadyPayload {
  path: string;
  title?: string;
}

export interface RavenRouteChangePayload {
  path: string;
  title?: string;
}

export interface RavenErrorPayload {
  message: string;
  details?: string;
}

export interface RavenNavigatePayload {
  path: string;
}

export interface RavenNavigateParentPayload {
  action: "back" | "home" | string; // 'back', 'home', or a path
}
